<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Opcje w grupie: {{ groupName }}</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/product-option-group/list">Grupy opcji</router-link>
        </li>
        <li class="active">
          <strong>{{ groupName }}</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Lista opcji</h5>
            <div class="ibox-tools">
              <router-link
                v-if="canAddOption"
                :to="`/product-option-group/${groupPk}/option/create`"
                class="btn btn-primary btn-sm"
              >
                <i class="fa fa-plus"></i> Dodaj nową opcję
              </router-link>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <div class="table-responsive table-search native-table-search">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="drag-column"></th>
                        <th>#</th>
                        <th>ID</th>
                        <th>Nazwa</th>
                        <th>Opis wewnętrzny</th>
                        <th>Dni realizacji</th>
                        <th>Linia technologiczna</th>
                        <th class="actions-column">Akcje</th>
                      </tr>
                      <tr class="filters-row">
                        <th></th>
                        <th></th>
                        <th>
                          <input
                            class="table-search native-header-input"
                            type="text"
                            :value="searchValue.pk || ''"
                            @input="
                              updateSearchValue('pk', $event.target.value)
                            "
                            @click.stop="isSearch = true"
                          />
                        </th>
                        <th>
                          <input
                            class="table-search native-header-input"
                            type="text"
                            :value="searchValue.label || ''"
                            @input="
                              updateSearchValue('label', $event.target.value)
                            "
                            @click.stop="isSearch = true"
                          />
                        </th>
                        <th>
                          <input
                            class="table-search native-header-input"
                            type="text"
                            :value="searchValue.internal_description || ''"
                            @input="
                              updateSearchValue(
                                'internal_description',
                                $event.target.value
                              )
                            "
                            @click.stop="isSearch = true"
                          />
                        </th>
                        <th>
                          <input
                            class="table-search native-header-input"
                            type="text"
                            :value="searchValue.realization_days || ''"
                            @input="
                              updateSearchValue(
                                'realization_days',
                                $event.target.value
                              )
                            "
                            @click.stop="isSearch = true"
                          />
                        </th>
                        <th>
                          <label class="tech-line-filter" @click.stop>
                            <input
                              type="checkbox"
                              :checked="Boolean(searchValue.tech_line)"
                              @change="
                                updateSearchValue(
                                  'tech_line',
                                  $event.target.checked
                                )
                              "
                            />
                          </label>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td colspan="8" class="text-center">Ładowanie...</td>
                      </tr>
                      <tr v-else-if="!items.length">
                        <td colspan="8" class="text-center">Brak wyników</td>
                      </tr>
                      <template v-else>
                        <tr
                          v-for="(item, index) in items"
                          :key="item.pk"
                          :class="bodyRowClassName(item)"
                          :draggable="canReorder"
                          @dragstart="onOptionDragStart(index, $event)"
                          @dragover="onOptionDragOver(index, $event)"
                          @drop="onOptionDrop(index, $event)"
                          @dragend="onOptionDragEnd"
                        >
                          <td class="drag-column" @click.stop>
                            <span
                              v-if="canReorder"
                              class="drag-handle"
                              title="Przeciągnij, aby zmienić kolejność"
                            >
                              <i class="fa fa-bars"></i>
                            </span>
                          </td>
                          <td>{{ rowNumber(index) }}</td>
                          <td>{{ item.pk }}</td>
                          <td>{{ getOptionName(item) }}</td>
                          <td>
                            <span v-html="getOptionDescription(item)"></span>
                          </td>
                          <td>
                            <span
                              v-if="
                                item.realization_days !== undefined &&
                                item.realization_days !== null
                              "
                            >
                              {{ item.realization_days }}
                            </span>
                          </td>
                          <td>
                            <span v-if="hasTechLine(item)">✓</span>
                            <span v-else>✗</span>
                          </td>
                          <td class="actions-column" @click.stop>
                            <button
                              v-if="canChangeOption"
                              class="btn btn-warning btn-xs"
                              title="Edytuj"
                              @click="editOption(item.pk)"
                            >
                              <i class="fa fa-pencil"></i>
                            </button>
                            <button
                              v-if="canDeleteOption"
                              @click.stop="
                                showModal = item.pk;
                                deleteName = getOptionName(item);
                              "
                              class="btn btn-danger btn-xs ml-5"
                              title="Usuń"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteOption(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { productOptionPermissionsConst } from "../../constants/productConstants";
import { useRoute, useRouter } from "vue-router";
import Modal from "../caffeprint/Modal.vue";

export default {
  name: "ProductOptionsInGroup",
  components: {
    Modal,
  },
  setup() {
    const store = useStore();
    const canAddOption = computed(() =>
      hasPermission(productOptionPermissionsConst.add)
    );
    const canChangeOption = computed(() =>
      hasPermission(productOptionPermissionsConst.update)
    );
    const canDeleteOption = computed(() =>
      hasPermission(productOptionPermissionsConst.delete)
    );
    const route = useRoute();
    const router = useRouter();

    const adminOptionsListByGroupData = computed(
      () => store.getters.getAdminOptionsListByGroupData
    );
    const pogData = computed(() => store.getters.getPOGData);
    const deleteOptionData = computed(() => store.getters.getDeleteOptionData);

    const groupPk = ref(Number(route.params.group_pk));
    const groupName = ref("");

    const items = ref([]);
    const itemsAll = ref(0);
    const loading = ref(true);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const showModal = ref(false);
    const deleteName = ref("");
    const searchValue = ref({});
    const isSearch = ref(false);
    let searchTimeout = null;
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });
    const draggedOptionPk = ref(null);
    const dragOverOptionPk = ref(null);
    // Reordering persists a new position on the option, so it is an edit.
    const canReorder = computed(() => canChangeOption.value);

    const fetchOptions = async () => {
      loading.value = true;
      await store.dispatch("getAdminOptionsListByGroup", {
        group_pk: groupPk.value,
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: "position",
        search: searchValue.value,
      });
    };

    const fetchGroup = async () => {
      await store.dispatch("getPOG", { pk: groupPk.value });
    };

    const getOptionName = (item) => {
      return item.label_pl || item.label || item.name || "";
    };

    const getOptionDescription = (item) => {
      return item.internal_description || "";
    };

    const hasTechLine = (item) => {
      return Boolean(item.tech_line);
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };
    const updateSearchValue = (key, value) => {
      searchValue.value = {
        ...searchValue.value,
        [key]: value,
      };
      search();
    };
    const search = () => {
      isSearch.value = true;
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        selectPage(1);
        fetchOptions();
        isSearch.value = false;
      }, 500);
    };

    const rowNumber = (index) => {
      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue =
        Number(serverOptions.value.rowsPerPage) || defRowsPerPage.value;

      return (page - 1) * rowsPerPageValue + index + 1;
    };

    const bodyRowClassName = (item) => {
      const classes = ["native-data-row"];

      if (canReorder.value) {
        classes.push("option-reorder-enabled");
      }
      if (dragOverOptionPk.value === item.pk) {
        classes.push("drag-over-row");
      }

      return classes.join(" ");
    };

    const editOption = (pk) => {
      router.push(`/product-option-group/${groupPk.value}/option/${pk}/edit`);
    };

    const deleteOption = (pk) => {
      showModal.value = false;
      if (!canDeleteOption.value) {
        return;
      }
      store.dispatch("deleteOption", pk);
    };

    const onOptionDragStart = (index, event) => {
      if (!canReorder.value) {
        event.preventDefault();
        return;
      }

      const item = items.value[index];
      if (!item) {
        event.preventDefault();
        return;
      }

      draggedOptionPk.value = item.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
      }
    };

    const onOptionDragOver = (index, event) => {
      if (!canReorder.value) {
        return;
      }

      const item = items.value[index];
      if (!item) {
        return;
      }

      event.preventDefault();
      dragOverOptionPk.value = item.pk;
    };

    const onOptionDragEnd = () => {
      draggedOptionPk.value = null;
      dragOverOptionPk.value = null;
    };

    const onOptionDrop = async (index, event) => {
      if (!canReorder.value) {
        return;
      }

      event.preventDefault();
      const targetItem = items.value[index];

      if (
        !draggedOptionPk.value ||
        !targetItem ||
        draggedOptionPk.value === targetItem.pk
      ) {
        onOptionDragEnd();
        return;
      }

      const fromIndex = items.value.findIndex(
        (item) => item.pk === draggedOptionPk.value
      );
      const toIndex = items.value.findIndex(
        (item) => item.pk === targetItem.pk
      );

      if (fromIndex < 0 || toIndex < 0) {
        onOptionDragEnd();
        return;
      }

      const [movedOption] = items.value.splice(fromIndex, 1);
      items.value.splice(toIndex, 0, movedOption);

      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue =
        Number(serverOptions.value.rowsPerPage) || defRowsPerPage.value;
      const newPosition = (page - 1) * rowsPerPageValue + toIndex + 1;

      onOptionDragEnd();

      try {
        await store.dispatch("reorderOption", {
          pk: movedOption.pk,
          position: newPosition,
        });
        store.dispatch("showToaster", {
          type: "success",
          content: "Kolejność opcji została zaktualizowana",
        });
        await fetchOptions();
      } catch (e) {
        await fetchOptions();
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności opcji",
        });
      }
    };

    onMounted(() => {
      fetchGroup();
      fetchOptions();
    });

    onBeforeUnmount(() => {
      clearTimeout(searchTimeout);
    });

    watch(
      () => pogData.value,
      function (newValue) {
        if (newValue && newValue.data) {
          groupName.value = newValue.data.name_pl || "";
        }
      }
    );

    watch(
      () => groupName.value,
      function (newValue) {
        if (!newValue) {
          groupName.value = `Grupa ${groupPk.value}`;
        }
      },
      { immediate: true }
    );

    watch(
      () => adminOptionsListByGroupData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
          // Try to get group name from first option data as fallback
          if (!groupName.value && element.options_group_name) {
            groupName.value = element.options_group_name;
          }
        });
        loading.value = false;
      }
    );

    watch(
      () => deleteOptionData.value,
      function (newValue) {
        if (!newValue) return;
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Opcja została usunięta",
          });
          fetchOptions();
        } else if (newValue.status && newValue.status !== 204) {
          store.dispatch("showToaster", {
            type: "error",
            content: "Nie udało się usunąć opcji",
          });
        }
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          fetchOptions();
        }
      },
      { deep: true }
    );

    return {
      canAddOption,
      canChangeOption,
      canDeleteOption,
      items,
      itemsAll,
      loading,
      serverOptions,
      canReorder,
      rowsPerPage,
      groupPk,
      groupName,
      showModal,
      deleteName,
      searchValue,
      isSearch,
      rowNumber,
      bodyRowClassName,
      setRowsPerPage,
      updateSearchValue,
      search,
      selectPage,
      getOptionName,
      getOptionDescription,
      hasTechLine,
      editOption,
      deleteOption,
      onOptionDragStart,
      onOptionDragOver,
      onOptionDrop,
      onOptionDragEnd,
    };
  },
};
</script>

<style scoped>
.native-table-search {
  margin-top: 15px;
}

.native-table-search table {
  margin-bottom: 0;
}

.filters-row th {
  padding: 5px !important;
}

.native-header-input {
  width: 100%;
  border: 1px solid #e5e6e7;
  padding: 3px 6px;
}

.tech-line-filter {
  display: flex;
  justify-content: center;
  margin: 0;
}

.drag-column {
  width: 50px;
}

.actions-column {
  width: 100px;
  white-space: nowrap;
}

.drag-handle {
  display: inline-block;
  cursor: move;
  color: #676a6c;
}

.native-data-row {
  cursor: default;
}

.native-data-row.option-reorder-enabled {
  cursor: move;
}

.native-data-row.drag-over-row {
  background-color: #f3f3f4;
}
</style>
